import type { PaginationMeta } from '@/types'

export type UserRole = 'ADMIN' | 'MANAGER' | 'MERCHANT'

export interface AdminUser {
  id: string
  email: string
  display_name: string | null
  role: UserRole
  is_active: boolean
  auth_provider: string
  last_login_at: string | null
  created_at: string
  updated_at: string
}

export interface PaginatedAdminUsersResponse {
  data: AdminUser[]
  pagination: PaginationMeta
}

export const ADMIN_USER_ROLE_OPTIONS: {
  value: UserRole | 'all'
  label: string
}[] = [
  { value: 'all', label: 'All Roles' },
  { value: 'ADMIN', label: 'Admin' },
  { value: 'MANAGER', label: 'Manager' },
  { value: 'MERCHANT', label: 'Merchant' },
]
